import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import GuestDetailsPage from './components/GuestDetailsPage'; // <-- IMPORTANT: Must be imported
import './index.css';

import Navbar from './components/Navbar';
import Home from './components/Home';
import GuestCheckIn from './components/GuestCheckIn';
import GuestCheckOut from './components/GuestCheckOut';
import AdminDashboard from './components/AdminDashboard';
import MainDashboard from './components/MainDashboard';
import Login from './components/Login';
import GuestDashboard from './components/GuestDashboard';
import GuestStatus from './components/GuestStatus';
import './i18n/config';

// ---------- PROTECTED ROUTE ----------
const ProtectedRoute = ({ element, requiredRole }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div className="container card">Loading user...</div>;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (!requiredRole.includes(user.role)) {
        return <Navigate to="/" replace />;
    }

    return element;
};

// ---------- ROOT REDIRECTION ----------
const RedirectByRole = () => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div className="container card">Loading...</div>;
    }

    if (!user) {
        return <Home />;
    }

    switch (user.role) {
        case 'admin':
            return <Navigate to="/admin-dashboard" replace />;
        case 'hotel':
            return <Navigate to="/hotel-dashboard" replace />;
        case 'guest':
            return <Navigate to="/guest/dashboard" replace />;
        default:
            return <Home />;
    }
};
// ---------- MAIN APP ----------
export default function App() {
    return (
        <AuthProvider>
            <Router>
                <Navbar />
                <div style={{ paddingTop: '120px', minHeight: '100vh' }}>
                    <Routes>
                        {/* HOME ROUTE */}
                        <Route path="/" element={<RedirectByRole />} />

                        {/* PUBLIC ROUTES */}
                        <Route path="/checkin" element={<GuestCheckIn />} />
                        <Route path="/checkout" element={<GuestCheckOut />} />
                        <Route path="/status" element={<GuestStatus />} />
                        <Route path="/login" element={<Login />} />

                        {/* ADMIN DASHBOARD */}
                        <Route
                            path="/admin-dashboard"
                            element={
                                <ProtectedRoute
                                    element={<AdminDashboard />}
                                    requiredRole={['admin']}
                                />
                                
                                
                            }
                            
                        />

                        {/* HOTEL DASHBOARD */}
                        <Route path="/guest-details/:guestId" element={<GuestDetailsPage />} />
                        <Route
                            path="/hotel-dashboard"
                            element={
                                <ProtectedRoute
                                    element={
                                        
                                            <MainDashboard />
                                       
                                    }
                                    requiredRole={['hotel']}
                                />
                            }
                        />

                        {/* GUEST DASHBOARD */}
                        <Route
                            path="/guest/dashboard"
                            element={
                                <ProtectedRoute
                                    element={<GuestDashboard />}
                                    requiredRole={['guest']}
                                />
                            }
                        />

                        {/* 404 fallback */}
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </div>
            </Router>
        </AuthProvider>
    );
}
